const identity = x => x;
const getUndefined = () => {};

export default function createRavenMiddleware(raven, options = {}) {
  // TODO: Validate options.
  const {
    breadcrumbDataFromAction = getUndefined,
    actionTransformer = identity,
    stateTransformer = getUndefined,
    breadcrumbCategory = 'redux-action',
  } = options;

  return store => {
    let lastAction;

    raven.setDataCallback((data, original) => {
      data.extra.lastAction = actionTransformer(lastAction);
      data.extra.state = stateTransformer(store.getState());
      return original ? original(data) : data;
    });

    return next => action => {
      // Log the action taken to Raven so that we have narrative context in our
      // error report.
      raven.captureBreadcrumb({
        category: breadcrumbCategory,
        message: action.type,
        data: breadcrumbDataFromAction(action),
      });

      lastAction = action;
      try {
        return next(action);
      } catch (ex) {
        raven.captureException(ex);
      }
    };
  };
}
